import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import Button from '@/components/button';
import { EMBED_URL } from '@/constants/urls';
import {
  getCookie,
  hasUserDismissedBannerCookie,
  saveTrackingPermissionCookie,
  saveUserDismissedBannerCookie,
} from '@/utils/cookies';

export const TrackingConsentModal: FC = () => {
  const pathName = usePathname();

  const [hasUserDismissedBanner, setHasUserDismissedBanner] = useState(false);
  const [hasRendered, setHasRendered] = useState(false);

  useEffect(() => {
    setHasRendered(true);
  }, []);

  const handleConfirm = useCallback(() => {
    saveTrackingPermissionCookie();
    saveUserDismissedBannerCookie();
    setHasUserDismissedBanner(true);
  }, []);

  const shouldShow = useMemo(() => {
    return (
      hasRendered &&
      !hasUserDismissedBanner &&
      !getCookie(hasUserDismissedBannerCookie) &&
      !pathName?.includes(EMBED_URL)
    );
  }, [hasRendered, hasUserDismissedBanner, pathName]);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="fixed bottom-[30px] left-[5%] z-[3000] flex w-[90%] flex-col items-center bg-gray-90 p-[10px] text-xxs font-normal text-gray-10 md:left-[calc(50vw-300px)] md:w-[600px]">
      <span>
        This site uses third-party cookies and tracking technologies to deliver
        its services and analyze traffic. These third parties may use your
        information for their own purposes, as described in our Privacy Policy.
      </span>
      <div className="mt-[10px] flex flex-row gap-[10px] text-xs font-medium">
        <Link
          className="flex items-center justify-center border-[2px] border-gray-10 px-3 text-gray-10"
          href="/privacy-policy"
        >
          Privacy Policy
        </Link>
        <Button
          className="h-8 bg-gray-10 text-xs text-gray-90 selection:bg-gray-10 hover:bg-gray-10 active:bg-gray-10"
          onClick={handleConfirm}
        >
          I Understand
        </Button>
      </div>
    </div>
  );
};
